(function () {
  function isPdfHref(href) {
    if (!href || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
      return false;
    }
    if (href.trim().charAt(0) === '#') {
      return false;
    }
    try {
      var path = href.split('?')[0].split('#')[0];
      return /\.pdf$/i.test(path);
    } catch (e) {
      return false;
    }
  }

  function shouldInterceptPdfClick(evt, link) {
    if (evt.defaultPrevented) {
      return false;
    }
    if (typeof evt.button === 'number' && evt.button !== 0) {
      return false;
    }
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
      return false;
    }
    if (link.hasAttribute('download')) {
      return false;
    }
    if (link.getAttribute('data-pdf-modal') === 'false') {
      return false;
    }
    if (link.closest('#ProductPdfModal')) {
      return false;
    }
    return true;
  }

  function init() {
    var modalEl = document.getElementById('ProductPdfModal');
    if (!modalEl || typeof theme === 'undefined' || !theme.Modals) {
      return;
    }

    var iframe = modalEl.querySelector('[data-product-pdf-frame]');
    var titleEl = document.getElementById('ProductPdfModalTitle');

    var pdfModal = new theme.Modals('ProductPdfModal', 'product-pdf-modal-open-link', {});
    if (!pdfModal || !iframe) {
      return;
    }

    document.addEventListener(
      'click',
      function (evt) {
        var link = evt.target.closest('a[href]');
        if (!link) {
          return;
        }
        var href = link.getAttribute('href');
        if (!isPdfHref(href)) {
          return;
        }
        if (!shouldInterceptPdfClick(evt, link)) {
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        var label = (link.textContent || '').trim();
        if (titleEl) {
          titleEl.textContent = label || 'PDF';
        }
        iframe.setAttribute('title', label || 'PDF');
        iframe.setAttribute('src', href);
        pdfModal.open();
      },
      true
    );

    document.addEventListener('modalClose.ProductPdfModal', function () {
      iframe.setAttribute('src', 'about:blank');
      if (titleEl) {
        titleEl.textContent = 'PDF';
      }
      iframe.setAttribute('title', 'PDF');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
